import { render, staticRenderFns } from "./ToggleCard.vue?vue&type=template&id=48ce7b75&scoped=true&"
import script from "./ToggleCard.vue?vue&type=script&lang=ts&"
export * from "./ToggleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce7b75",
  null
  
)

export default component.exports